import type { FunctionComponent } from 'react';
import { useMemo } from 'react';

import { Overview } from '../../components/overview/overview';
import { useActivtyFeed } from '../../hooks/use-activity-feed';
import { useBalance } from '../../hooks/use-balance';
import { IUserActivitiesOrderBy } from '../../queries/activity.graphql';
import { EventCode } from '../../util/events.constants';

export const OverviewPage: FunctionComponent = () => {
    const { wallets } = useBalance();
    const filter = useMemo(
        () => ({
            orderBy: [IUserActivitiesOrderBy.LastUpdatedOnDesc],
            filters: {
                feedType: {
                    in: [
                        EventCode.USER_REGISTRATION,
                        EventCode.USER_LOGIN_ERROR,
                        EventCode.USER_LOGIN,
                        EventCode.USER_DEPOSIT_SUCCESSFUL,
                        EventCode.USER_WITHDRAWAL_SUCCESSFUL,
                    ],
                },
            },
        }),
        [],
    );
    const { feed, fetchMore, hasMore } = useActivtyFeed(filter);

    return (
        <Overview
            wallets={wallets || []}
            activityFeed={feed}
            onLoadMoreActivities={fetchMore}
            hasMoreActivities={hasMore}
        />
    );
};
